<section class="mac-does-section">
    <div class="mac-does-container">
        <div class="macdoes-container">
            <img src="assets/images/macdoes/MD1.jpg" alt="Mac Does" class="md1">
        </div>
        <div class="button-container">
            <button class="know-more-btn" routerLink="/contact">Contact Us</button>
        </div>
    </div>

    <div class="macdoes-multitask">
        <div class="image-column">
            <img src="assets/images/macdoes/MD2.jpg" alt="Mac Does" class="md2">
        </div>
        <div class="image-column">
            <img src="assets/images/macdoes/MD3.jpg" alt="Mac Does" class="md3">
        </div>
    </div>

    <div class="macdoes-battery">
        <div class="macdoes-container-battery">
            <img src="assets/images/macdoes/MD4.jpg" alt="Mac Does" class="md4">
        </div>
        <!--  <div class="button-container">
            <button class="know-more-btn">Know More</button>
        </div> -->
    </div>

    <div class="macdoes-multitask">
        <div class="image-column">
            <img src="assets/images/macdoes/MD5.jpg" alt="Mac Does" class="md5">
        </div>
        <div class="image-column md6-container">
            <img src="assets/images/macdoes/MD6.jpg" alt="Mac Does" class="md6">
        </div>
    </div>

    <div class="macdoes-multitask">
        <div class="image-column">
            <img src="assets/images/macdoes/MD7.jpg" alt="Mac Does" class="md7">
        </div>
        <div class="image-column">
            <img src="assets/images/macdoes/MD8.jpg" alt="Mac Does" class="md8">
        </div>
    </div>


    <div class="macdoes-multitask">
        <div class="image-column">
            <img src="assets/images/macdoes/MD9.jpg" alt="Mac Does" class="md5">
        </div>
        <div class="image-column md6-container">
            <img src="assets/images/macdoes/MD10.jpg" alt="Mac Does" class="md6">
        </div>
    </div>

    <div class="macdoes-multitask">
        <div class="image-column">
            <img src="assets/images/macdoes/MD11.jpg" alt="Mac Does" class="md7">
        </div>
        <div class="image-column">
            <img src="assets/images/macdoes/MD12.jpg" alt="Mac Does" class="md8">
        </div>
    </div>

    
        <div class="resources-section">
            <h2>Resources</h2>
            <div class="resources-container">
                <div class="resource-item">
                    <img src="assets/images/macdoes/appleicon.png" alt="AppleCare">
                    <h3>AppleCare Professional Support</h3>
                    <a href="/contact" target="_blank">Learn More</a>
                </div>
                <div class="resource-item">
                    <img src="assets/images/macdoes/deployment.png" alt="Deployment">
                    <h3>Deployment and Management Guide</h3>
                    <a href="assets/pdfs/Deployment-and-Management-Nov-2019-English_L588549A-en_GB.pdf" target="_blank">Learn More</a>
                </div>
                <div class="resource-item">
                    <img src="assets/images/macdoes/finance.png" alt="Financial">
                    <h3>Apple Financial Services</h3>
                    <a href="/contact" target="_blank">Learn More</a>
                </div>
                <div class="resource-item">
                    <img src="assets/images/macdoes/usericon.png" alt="Choice">
                    <h3>Employee Choice Guide For IT</h3>
                    <a href="assets/pdfs/Employee_Choice_Guide_for_IT-1.pdf" target="_blank">Learn More</a>
                </div>
                <div class="resource-item">
                    <img src="assets/images/macdoes/security.png" alt="Security">
                    <h3>Platform Security Guide</h3>
                    <a href="assets/pdfs/Platform-Security-Nov-2019_L588600A-en_GB.pdf" target="_blank">Learn More</a>
                </div>
                <div class="resource-item">
                    <img src="assets/images/macdoes/investment.png" alt="Investment">
                    <h3>A Smart Investment</h3>
                    <a href="assets/pdfs/apple-at-work-smart-investment.pdf" target="_blank">Learn More</a>
                </div>
            </div>
            <div class="get-started">
                <h2>Let's Get Started</h2>
                <p>Talk to an expert to learn more about Mac for Work</p>
                <button class="get-in-touch-btn" routerLink="/contact">Get in Touch</button>
            </div>
        </div>
   
</section>